module.exports = __webpack_public_path__ + "media/images/landing/mobile-app-932c3d0da24bb745765b0b1d3db93ecc.png";